import React from 'react';
import './WeeklyEvents.css'; // We will create this next

const WeeklyEvents = ({ events }) => {
  // Debug: If the screen is blank, this will tell us if 'events' is empty
  if (!events || events.length === 0) {
    return (
      <div className="no-events-container">
        <p className="no-events">No upcoming events found in the calendar.</p>
        <small>Check back later for updates!</small>
      </div>
    );
  }

  return (
    <div className="upcoming-events-list">
      {events.map((event, index) => (
        <div key={`${event.dayNumber}-${index}`} className="event-row">
          <div className="event-date-side">
            <div className="date-badge">
              <span className="event-day-num">{event.dayNumber}</span>
              <span className="event-month">{event.month}</span>
            </div>
            <div className="event-time-label">{event.time}</div>
          </div>

          <div className="event-content-side">
            <h4 className="event-title">{event.title}</h4>
            {event.location && (
              <p className="event-location">
                <span className="icon">📍</span> {event.location}
              </p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default WeeklyEvents;